module.exports = __webpack_public_path__ + "static/img/chanping23.964d584.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/srzq/chanping23.jpg
// module id = lNrR
// module chunks = 0